import {
    SearchableSelect,
    SearchableSelectWrapperProps,
} from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";
import {
    StepTypeStartContext,
    useStepTypeSelectOptions,
} from "components/UI/Selects/StepTypeSelectSearchable/useStepTypeSelectOptions.ts";

interface StepTypeSelectSearchableProps extends SearchableSelectWrapperProps {
    startContext?: StepTypeStartContext;
}

export const StepTypeSelectSearchable = ({ startContext, ...props }: StepTypeSelectSearchableProps) => {
    const hookResult = useStepTypeSelectOptions(startContext);

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace="forms.general-fields.step_type"
            {...props}
            size={props.size ?? "middle"}
        />
    );
};
